<template>
  <el-container id="resvGl">
    <el-header style="height:38px;line-height:30px;padding-left:16px;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main1">
      <el-main :style=divStyle>
        <div style="display:flex;height:9vh;width:100%;margin:0">
          <div style="display:flex;width:33.3%;background-color:#FFFFFF;border-radius: 5px 5px 5px 5px;">
            <div style="width:100px;margin:1vh">
              <p style="margin: 0;color: #6B7280">未开始预约</p>
              <p style="font-weight:bold;margin-top:0;margin-left:3px;font-size:20px">{{ notStarted }}</p>
            </div>
          </div>
          <div
              style="display:flex;width:33.3%;margin-left:5px;background-color:#FFFFFF;border-radius: 5px 5px 5px 5px;">
            <div style="width:100px;margin:1vh">
              <p style="margin:0;color: #6B7280">进行中预约</p>
              <p style="font-weight:bold;margin-top:0;margin-left:3px;font-size:20px">{{ inProgress }}</p>
            </div>
          </div>
          <div
              style="display:flex;width:33.3%;margin-left:5px;background-color:#FFFFFF;border-radius: 5px 5px 5px 5px;">
            <div style="width:100px;margin:1vh">
              <p style="margin: 0;color: #6B7280">已结束预约</p>
              <p style="font-weight:bold;margin-top:0;margin-left:3px;font-size:20px">{{ completed }}</p>
            </div>
          </div>
        </div>
        <div style="display:flex;margin-top:5px;max-width:100%;">
          <div style="width:49.5%;padding-left:1vh;background-color: #FFFFFF">
            <p>预约趋势
              <el-radio-group v-model="but_qs" style="margin-left:5px" @change="getAppointInOneDay">
                <el-radio-button label="日"></el-radio-button>
                <el-radio-button label="周"></el-radio-button>
                <el-radio-button label="月"></el-radio-button>
                <el-radio-button label="年"></el-radio-button>
              </el-radio-group>
              <el-date-picker
                  v-model="ediDay"
                  type="date"
                  @change="getAppointInOneDay"
                  :clearable="false"
                  placeholder="选择日期">
              </el-date-picker>
            </p>
            <div style="height: 20vh">
              <div id="myChart4" style="width:100%; height:100%;margin-bottom:0px"> <!--曲线图-->
              </div>
            </div>
          </div>
          <div style="width:49%;padding-left:1vh;margin-left:5px;background-color: #FFFFFF">
            <p>预约类型占比
              <el-radio-group v-model="but_zb" style="margin-left:5px" @change="getAppointRatio">
                <el-radio-button label="日"></el-radio-button>
                <el-radio-button label="周"></el-radio-button>
                <el-radio-button label="月"></el-radio-button>
                <el-radio-button label="年"></el-radio-button>
              </el-radio-group>
              <el-date-picker
                  v-model="ediDayZb"
                  type="date"
                  @change="getAppointRatio"
                  :clearable="false"
                  placeholder="选择日期">
              </el-date-picker>
            </p>
            <div style="height: 20vh">
              <div id="myChart1" style="width:100%; height:100%;margin-bottom:0px"> <!--饼状图-->
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top:5px;padding-left:10px;padding-right:10px;padding-top:10px;background-color: #FFFFFF">
          <div style="height:40px;background-color:#FFFFFF;display: flex">
            <el-date-picker
                v-model="ediTime"
                type="datetimerange"
                @change="getAppointList"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <el-input
                placeholder="用户信息"
                style="width:10vw;margin-left:5px"
                prefix-icon="el-icon-search"
                clearable
                @change="getAppointList"
                v-model="ediName">
            </el-input>
            <el-select v-model="edi_pid" ref='devSonSelect'
                       @click.native="getPid()" @change="getAppointList"
                       clearable filterable placeholder="预约项目"
                       style="width:8vw;margin-left:0.2vw">
              <el-option
                  v-for="item in li_pid"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="edi_state" ref='devSonSelect'
                       @change="getAppointList"
                       clearable filterable placeholder="预约状态"
                       style="width:8vw;margin-left:0.2vw">
              <el-option
                  v-for="item in li_state"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="edi_cleanState" ref='devSonSelect'
                       @change="getAppointList"
                       clearable filterable placeholder="清洁状态"
                       style="width:8vw;margin-left:0.2vw">
              <el-option
                  v-for="item in li_cleanState"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-button @click="toResvGlAdd" type="primary" size="medium" style="margin-left:auto">新增预约</el-button>
          </div>
          <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                    style="width:100%; font-size:13px; background:#FFFFFF;margin-top: 10px"
                    show-overflow-tooltip
                    :header-cell-style="{'height':'30px','text-align':'center','background':'#f4f4f4','color':'#0dA7C8'}">
            <el-table-column width="01" sortable/>
            <div v-for="(d,item) in this.defHead">
              <el-table-column :key=item :prop=d.val :label=d.key :width="d.w">
              </el-table-column>
            </div>
            <el-table-column
                label="操作"
                width="200">
              <template slot-scope="scope">
                <el-button @click="onCheck(scope.row)" type="text" size="small"
                           style="color:#4B5563;font-size: 14px">查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            style="float:right; margin-right:0.5vw;margin-top:5px;color: #000000;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange1"
            :current-page="page"
            :page-sizes="[10,20,30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </el-main>
      <el-footer style="background-color:#F4F4F4;height:1px;margin-bottom:10px;padding:0"></el-footer>
    </el-container>
    <el-dialog :title=titles center :close-on-click-modal="false"
               width="35vw" class="dialogApp"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiApp'> <!--v-draggable 拖动-->
      <div
          style="display:flex;margin-bottom:10px;width:100%;line-height:0.3;text-align:left;align-items:center;">
        <div style="width:50%">
          <el-descriptions class="margin-top" title="基本信息" :column="1" direction="horizontal">
            <el-descriptions-item label="预约编号">{{ showInfo.id }}</el-descriptions-item>
            <el-descriptions-item label="用户姓名">{{ showInfo.userName }}</el-descriptions-item>
            <el-descriptions-item label="用户ID">{{ showInfo.userId }}</el-descriptions-item>
            <el-descriptions-item label="联系方式">{{ showInfo.applyNumber }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="width:50%">
          <el-descriptions class="margin-top" title="时间信息" :column="1" :colon="false" direction="horizontal">
            <el-descriptions-item label="预约日期:">{{ showInfo.time }}</el-descriptions-item>
            <el-descriptions-item label="开始时间:">{{ showInfo.beginExpDate }}</el-descriptions-item>
            <el-descriptions-item label="结束时间:">{{ showInfo.endExpDate }}</el-descriptions-item>
            <el-descriptions-item label=""></el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div
          style="display:flex;margin-bottom:10px;width:100%;line-height:0.3;text-align:left;align-items:center;">
        <div style="width:50%">
          <el-descriptions class="margin-top" title="区域信息" :column="1" direction="horizontal">
            <el-descriptions-item label="预约项目">{{ showInfo.roomName }}</el-descriptions-item>
            <el-descriptions-item label="区域位置">{{ showInfo.roomName }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="width:50%">
          <el-descriptions class="margin-top" title="状态信息" :column="1" direction="horizontal">
            <el-descriptions-item label="预约状态">{{ showInfo.state }}</el-descriptions-item>
            <el-descriptions-item label="清洁状态">{{ showInfo.cleanState }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div>
        <p style="font-size:17px;font-weight:bold;margin-bottom:6px">服务评价</p>
        <div style="display:flex">
          <p style="margin:0;width:180px;color:#717578;font-size:15px">您对本次服务满意吗？</p>
          <el-rate
              v-model="showInfo.service"
              disabled
              show-score
              text-color="#ff9900"
              score-template="{value}">
          </el-rate>
        </div>
        <div style="display:flex">
          <p style="margin:0;width:180px;color:#717578;font-size:15px">您对本次活动内容满意吗？</p>
          <el-rate
              v-model="showInfo.content"
              disabled
              show-score
              text-color="#ff9900"
              score-template="{value}">
          </el-rate>
        </div>
        <div style="display:flex">
          <p style="margin:0;width:180px;color:#717578;font-size:15px">您对本次活动环境满意吗？</p>
          <el-rate
              v-model="showInfo.environment"
              disabled
              show-score
              text-color="#ff9900"
              score-template="{value}">
          </el-rate>
        </div>
        <div style="display:flex">
          <p style="margin:0;width:180px;color:#717578;font-size:15px">您对本次活动设施满意吗？</p>
          <el-rate
              v-model="showInfo.facilities"
              disabled
              show-score
              text-color="#ff9900"
              score-template="{value}">
          </el-rate>
        </div>
      </div>
      <div style="margin-bottom:10px">
        <p style="font-size:17px;font-weight:bold;margin-bottom:6px">更多反馈</p>
        <el-input v-model="showInfo.more" :disabled="true"></el-input>
      </div>
      <div style="display:flex;width:100%">
        <el-button type="primary" @click="daiApp=false" style="margin-left:auto;margin-right:5px">返回</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import moment from "moment/moment";

export default {
  name:"resvGl",
  components:{ /*引入组件*/

  },
  data() {
    return {
      h_text:"预约管理",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""}
      ],
      edi_pid:"",
      li_pid:[],
      divStyle:{
        backgroundColor:'#F4F4F4',
        overflow:'auto',
        paddingLeft:'16px',
        paddingRight:'16px',
        maxHeight:window.innerHeight - 50
      },
      daiApp:false,
      showInfo:{},
      titles:"预约详情",
      ediTime:"",
      ediName:"",
      ediDay:new Date(),
      ediDayZb:new Date(),
      completed:0,
      inProgress:0,
      notStarted:0,
      pidPage:1,
      pidPageSize:30,
      pidTotal:30,
      page:1,
      pageSize:10,
      total:0,
      defHead:[
        {'key':"预约编号",'val':"id","w":"200px"},
        {'key':"用户信息",'val':"userName","w":"auto"},
        {'key':"预约项目",'val':"roomName","w":"auto"},
        {'key':"开始时间",'val':"beginExpDate","w":"auto"},
        {'key':"结束时间",'val':"endExpDate","w":"auto"},
        {'key':"同行关怀",'val':"cares","w":"auto"},
        {'key':"预约服务",'val':"userServer","w":"auto"},
        {'key':"状态",'val':"state","w":"auto"},
        {'key':"清洁状态",'val':"cleanState","w":"auto"}
      ],
      tabData:[],
      but_qs:"周",
      but_zb:"周",
      bj_dev_txt:"#ccc",
      bj_tab:"#FFFFFF", /*#283A4D*/
      qs_x:[
        1
      ],
      qs_list_name:[],
      series:[],
      zb_list:[],
      edi_state:"",
      li_state:[
        {label:"待审批",value:1},
        {label:"未开始",value:2},
        {label:"进行中",value:3},
        {label:"已结束",value:4},
        {label:"已取消",value:5},
        {label:"未通过",value:6}
      ],
      edi_cleanState:"",
      li_cleanState:[
        {label:"待清洁",value:1},
        {label:"准备清洁",value:2},
        {label:"已清洁",value:3}
      ]
    };
  },
  methods:{ /*方法存放*/
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAppointList();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.getAppointList();
    },
    toResvGlAdd() {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/hsResvGlAdd'
      });
    },
    onCheck(row) {
      console.log(row);
      this.showInfo = {
        id:row.id,
        state:row.state,
        beginExpDate:row.beginExpDate,
        endExpDate:row.endExpDate,
        time:row.time,
        userId:row.userId,
        userName:row.userName,
        applyNumber:row.applyNumber,
        roomName:row.roomName,
        cleanState:row.cleanState, /*清洁状态*/
        service:row.service,
        content:row.content,
        environment:row.environment, /*环境打分*/
        facilities:row.facilities, /*设施打分*/
        more:row.more, /*更多评价*/
        cares:row.cares /*同行标签*/
      };
      this.daiApp = true;
    },
    getPid() {
      if (this.pidPage > this.pidTotal / this.pidPageSize + 1) {
        return;
      }
      const params = {
        'page':this.pidPage,
        'pageSize':this.pidPageSize,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getRoomList,params,headers).then(res => {
        console.log("getRoomList：",res.data.data);
        this.pidTotal = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_pid;
        for (let i = 0; i < data.length; i++) {
          let d = {
            value:data[i]['id'],
            label:data[i]['name']
          };
          l.push(d);
        }
        this.li_pid = l;
        this.pidPage += 1;
        this.loading = false;
      }).catch(error => {
        console.log(error.data);
        this.loading = false;
        this.$message.error("获取设备类型失败");
      });
    },
    initQs(data,lt,t1) { /*初始化趋势折线图*/
      let li_name = [];
      let li_data = [];
      for (let i = 0; i < data.length; i++) {
        let name = "";
        let li_d = [];
        console.log(data[i][lt]);
        for (let j = 0; j < this.qs_x.length; j++) {
          let d = {};
          const re_d = data[i][lt].find(u => u[t1] === j);
          if (re_d) {
            name = re_d["roomName"];
            li_d.push(re_d["num"]);
          } else {
            li_d.push(0);
          }
        }
        if (name) {
          li_name.push(name);
          li_data.push(li_d);
        }
      }
      this.qs_list_name = li_name;
      let series = [];
      for (let i = 0; i < li_name.length; i++) {
        var color = '#' + Math.floor(Math.random() * 16777215).toString(16);
        let d = {
          name:li_name[i],
          data:li_data[i],
          type:'line',
          itemStyle:{
            color:color
          },
          areaStyle:{
            color:color // 底部填充颜色
          },
          tooltip:{
            valueFormatter:function (value) {
              return value;
            }
          }
        };
        series.push(d);
      }
      this.series = series;
      this.drawLine4();
    },
    drawLine1() {
      let myChart1 = this.$echarts.getInstanceByDom(
          document.getElementById('myChart1')
      );
      if (myChart1 == null) {  /*基于准备好的dom，初始化echarts实例*/
        this.myChart1 = this.$echarts.init(document.getElementById('myChart1'));
      } else {
        this.myChart1.clear();
      }
      this.myChart1.setOption({ /*绘制图表*/
        series:[
          {
            name:"", /*['女', '男']*/
            type:'pie',    // 设置图表类型为饼图
            radius:[
              '40%',
              '70%'
            ],  // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 66% 长kWh。
            data:this.zb_list,          // 数据数组，name 为数据项名称，value 为数据项值
            label:{ /*position:"", //标签的位置*/
              formatter:'{b}：{c}%',
              fontWeight:'normal',
              fontSize:13,
              color:this.bj_dev_txt,
              textStyle:{
                fontWeight:'bold' // 设置柱状图顶部的标签加粗
              }
            }
          }
        ]
      });
    },
    drawLine4() {
      let myChart4 = this.$echarts.getInstanceByDom(
          document.getElementById('myChart4')
      );
      if (myChart4 == null) {  /*基于准备好的dom，初始化echarts实例*/
        this.myChart4 = this.$echarts.init(document.getElementById('myChart4'));
      } else {
        this.myChart4.clear();
      }
      this.myChart4.setOption({ /*绘制图表*/
        title:{
          text:'', // 主标题
          subtext:'', // 副标题
          x:'left', // x轴方向对齐方式
          padding:[
            0,
            0,
            0,
            0
          ], /*上 右 下 左*/
          textStyle:{ /*图例文字的样式*/
            color:this.bj_dev_txt,
            fontSize:16
          }
        },
        tooltip:{
          trigger:'axis' // axis   item   none三个值
        },
        color:[
          '#4472C5',
          '#ED7C30',
          '#80FF80',
          '#FF8096',
          '#800080'
        ],
        legend:{
          orient:'horizontal', /*vertical*/
          x:'center',
          y:'top',
          padding:[
            20,
            0,
            0,
            0
          ], /*上 右 下 左*/
          data:this.qs_list_name,
          textStyle:{ /*图例文字的样式*/
            color:this.bj_dev_txt,
            fontSize:16
          }
        },
        grid:{
          left:'2%',
          right:'2%',
          bottom:'2%',
          containLabel:true
        },
        xAxis:{
          type:'category', // 还有其他的type，可以去官网喵两眼哦
          data:this.qs_x, // x轴数据
          name:'',  /*x轴名称*/
          show:true,
          axisLabel:{
            color:this.bj_dev_txt,
            fontSize:14
          }
        },
        yAxis:{
          type:'value',
          name:'',  /*y轴名称*/
          axisLabel:{
            color:this.bj_dev_txt,
            fontSize:14
          }
        },
        series:this.series
      });
    },
    getAppointRatio() { /*获取数据占比*/
      const params = {
        'type':0,
        'projectId':localStorage.getItem("projectId")
      };
      switch (this.but_zb) {
        case "日":
          params["type"] = 0;
          break;
        case "周":
          params["type"] = 1;
          break;
        case "月":
          params["type"] = 2;
          break;
        case "年":
          params["type"] = 3;
          break;
      }
      params["time"] = parseInt("" + this.ediDayZb.getTime() / 1000);
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getAppointRatio,params,headers).then(res => {
        console.log("getAppointRatio:",res.data.data);
        if (res.data.data["appointRoom"]) {
          let li_d = res.data.data["appointRoom"];
          if (li_d.length > 0) {
            let l_zb = [];
            for (let i = 0; i < li_d.length; i++) {
              let d = {
                value:(li_d[i]["ratio"] * 100).toFixed(2),
                name:li_d[i]["roomName"],
                itemStyle:{
                  color:'#' + Math.floor(Math.random() * 16777215).toString(16)
                }
              };
              l_zb.push(d);
            }
            this.zb_list = l_zb;
          } else {
            this.zb_list = [];
          }
        } else {
          this.zb_list = [];
        }
        this.drawLine1();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取占比数据失败");
        }
      });
    },
    getAppointTotal() {
      const params = {
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getAppointTotal,params,headers).then(res => {
        console.log("getAppointTotal:",res.data.data);
        this.completed = res.data.data.completed;
        this.inProgress = res.data.data.inProgress;
        this.notStarted = res.data.data.notStarted;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取统计数据失败");
        }
      });
    },
    getAppointInOneDay() {
      const params = {
        "type":0,
        'projectId':localStorage.getItem("projectId")
      };
      switch (this.but_qs) {
        case "日":
          params["type"] = 0;
          break;
        case "周":
          params["type"] = 1;
          break;
        case "月":
          params["type"] = 2;
          break;
        case "年":
          params["type"] = 3;
          break;
      }
      params["time"] = parseInt("" + this.ediDay.getTime() / 1000);
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getAppointInOneDay,params,headers).then(res => {
        console.log("getAppointInOneDay:",res.data.data);
        switch (this.but_qs) {
          case "日":
            if (res.data.data["appointDay"]) {
              this.qs_x = Array.from({length:24},(_,index) => index);
              this.initQs(res.data.data["appointDay"],"appointRoomHour","hour");
            } else {
              this.series = [];
              this.qs_list_name = [];
              this.drawLine4();
            }
            break;
          case "周":
            if (res.data.data["appointWeek"]) {
              this.qs_x = Array.from({length:8},(_,index) => index);
              this.initQs(res.data.data["appointWeek"],"appointRoomWeek","week");
            } else {
              this.series = [];
              this.qs_list_name = [];
              this.drawLine4();
            }
            break;
          case "月":
            if (res.data.data["appointMonth"]) {
              this.qs_x = Array.from({length:moment().daysInMonth() + 1},(_,index) => index);
              this.initQs(res.data.data["appointMonth"],"appointRoomMonth","day");
            } else {
              this.series = [];
              this.qs_list_name = [];
              this.drawLine4();
            }
            break;
          case "年":
            if (res.data.data["appointYearWithRoomId"]) {
              this.qs_x = Array.from({length:13},(_,index) => index);
              this.initQs(res.data.data["appointYearWithRoomId"],"appointRoomYear","month");
            } else {
              this.series = [];
              this.qs_list_name = [];
              this.drawLine4();
            }
            break;
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取曲线数据失败");
        }
      });
    },
    initAppointList(li_data) {
      let data = li_data['list'];
      let l_d = [];
      for (let i = 0; i < data.length; i++) {
        let d = {
          "id":data[i]["id"],
          "stateId":data[i]["stateId"],
          "time":data[i]["time"],
          "beginExpDate":data[i]["beginExpDate"],
          "endExpDate":data[i]["endExpDate"],
          "cares":"", /*同行标签*/
          "userServer":"", /*服务标签*/
          "roomName":"",
          "state":"",
          "userId":"",
          "applyNumber":"",
          "userName":"",
          "cleanState":"",
          service:5, /*服务打分*/
          content:5, /*内容打分*/
          environment:5, /*环境打分*/
          facilities:5, /*设施打分*/
          more:"" /*更多评价*/
        };
        for (let j = 0; j < data[i]["cares"].length; j++) {
          d["cares"] += data[i]["cares"][j]["name"] + "、";
        }
        if (data[i]["services"] && data[i]["services"].length > 0) {
          for (let j = 0; j < data[i]["services"].length; j++) {
            d["userServer"] += data[i]["services"][j]["name"] + "、";
          }
        }
        if (d["cares"].length > 0) {
          d["cares"] = d["cares"].slice(0,-1);
        }
        if (d["userServer"].length > 0) {
          d["userServer"] = d["userServer"].slice(0,-1);
        }
        if (data[i]["cleanState"] === 0 || data[i]["cleanState"] === 1) {
          d["cleanState"] = "待清洁";
        } else if (data[i]["cleanState"] === 2) {
          d["cleanState"] = "准备清洁";
        } else if (data[i]["cleanState"] === 3) {
          d["cleanState"] = "已清洁";
        }
        if (data[i]["room"]) {
          d["roomName"] = data[i]['room']['name'];
        }
        let re_d = this.li_state.find(item => item.value === d.stateId);
        if (re_d) {
          d["state"] = re_d.label;
        }
        d["userName"] = "";
        if (data[i]["user"]) {
          d["userId"] = data[i]['user']['accNo'];
          if (data[i]['user']['phoneNumber']) {
            d["applyNumber"] = data[i]['user']['phoneNumber'];
          } else {
            d["applyNumber"] = data[i]['user']['applyNumber'];
          }
          if (data[i]['user']['name']) {
            d["userName"] = data[i]['user']['name'];
          } else if (data[i]['user']["nickName"]) {
            d['userName'] = data[i]['user']["nickName"];
          } else if (data[i]['user']["userName"]) {
            d['userName'] = data[i]["userName"];
          }
        } else {
          if (data[i]["customNumber"]) { /*手机号*/
            d['applyNumber'] = data[i]["customNumber"];
          }
          if (data[i]["name"]) { /*用户名*/
            d['userName'] = data[i]["name"];
          } else if (data[i]["nickName"]) {
            d['userName'] = data[i]["nickName"];
          } else if (data[i]["userName"]) {
            d['userName'] = data[i]["userName"];
          }
        }
        if (data[i]["evaluate"]) { /*打分*/
          d["service"] = data[i]["evaluate"]["service"];
          d["content"] = data[i]["evaluate"]["content"];
          d["environment"] = data[i]["evaluate"]["environment"];
          d["facilities"] = data[i]["evaluate"]["facilities"];
          d["more"] = data[i]["evaluate"]["more"];
        }
        l_d.push(d);
      }
      this.total = li_data.total;
      this.tabData = l_d;
    },
    timestampToTime(timestamp) { /*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m + s;
    },
    getAppointList() { /*获取所有预约信息*/
      const params = {
        "page":this.page,
        "pageSize":this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.ediTime) {
        params['beginExpDate'] = this.timestampToTime(this.ediTime[0]);
        params['endExpDate'] = this.timestampToTime(this.ediTime[1]);
      }
      if (this.ediName) {
        params['userName'] = this.ediName;
      }
      if (this.edi_cleanState) {
        params['cleanState'] = this.edi_cleanState;
      }
      if (this.edi_pid) {/*房间id*/
        params['roomId'] = this.edi_pid;
      }
      if (this.edi_state) {/*状态id*/
        params['stateId'] = this.edi_state;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getAppointList,params,headers).then(res => {
        console.log("getAppointList:",res.data.data);
        if ("list" in res.data.data && res.data.data.list) {
          this.initAppointList(res.data.data);
        } else {
          this.total = 0;
          this.tabData = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取预约数据失败");
        }
      });
    },
    scolling() {
      let e = this.$refs.devSonSelect.$refs.scrollbar.$refs.wrap;
      if (this.loading) return; /*loading为真跳过-防止误触*/
      let loadMore = e.scrollHeight - e.scrollTop - 1 <= e.clientHeight;
      if (loadMore) { /*到底时触发 loadMore*/
        this.loadMore();
      }
    },
    loadMore() {
      this.loading = true; // 设置加载状态为 true，防止重复请求
      this.getPid();
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.$refs.devSonSelect.$refs.scrollbar.$refs.wrap.addEventListener('scroll',this.scolling); /*绑定下拉组件方法*/
    this.getAppointTotal();
    this.getAppointRatio();
    this.getAppointInOneDay();
    this.getAppointList();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true;
        return this.state;
      });
    }
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>

#resvGl {
  height: 95vh;
  margin: 0;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main1 {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 1vh;
  overflow-y: auto;
  border-radius: 5px 5px 5px 5px;
}

.dialogApp {
  .el-dialog__title {
    color: #000000;
    font-weight: 900;
  }

  .el-dialog__header {
    color: #000000;
    text-align: left;
    background: linear-gradient(to right, #6366F1, #10B981);
  }

  .el-dialog__body {
    color: #000000;
    background: #FFFFFF;
  }
}

.tab_adb {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/resvGl.vue